import cloneDeep from 'lodash.clonedeep';

const commonState = {
  policyChanges: {},
  policyHolder: {
    startDate: null,
    personCode: null,
    firstName: null,
    middleName: null,
    lastName: null,
    gender: null,
    DOB: null,
    mobile: null,
    preferredContactMethods: [],
    email: null,
    residentialAddress: {},
    postalAddress: {},
    differentPostalAddress: false,
    veteranCard: {
      startDate: null,
      haveVeteranCard: null,
      veteranCardType: '',
      veteranCardConditionOptions: [],
    },
    haveConcessionCard: null,
    selectedConcessionCardOptions: [{ name: '', number: '', expire: '' }],
    POBox: null,
    abd: null,
    lhc: {
      cae: null,
      overruledReason: null,
      date: null,
      dischargeDate: null,
    },
    portalAgeBasedDiscount: null,
  },
  partner: {
    keepAdult: true,
    personCode: null,
    firstName: null,
    middleName: null,
    lastName: null,
    gender: null,
    DOB: null,
    preferredContactMethods: [],
    mobile: null,
    email: null,
    address: null,
    differentPostalAddress: false,
    veteranCard: {
      startDate: null,
      haveVeteranCard: null,
      veteranCardType: '',
      veteranCardConditionOptions: [],
    },
    haveConcessionCard: null,
    selectedConcessionCardOptions: [{ name: '', number: '', expire: '' }],
    POBox: null,
    lhc: {
      cae: null,
      overruledReason: null,
      date: null,
      dischargeDate: null,
    },
    portalAgeBasedDiscount: null,
  },
  children: {
    existingChildren: [],
    newChildren: [],
  },
  eligibility: {
    serviceConnection: '',
    serviceConnectionName: '',
    veteranInfo: {
      rank: '',
      serviceAgency: '',
      serviceType: '',
    },
    enlistmentDate: '',
    sercatStatus: '',
    declaration: false,
    declarationDate: '',
    declarationExpiryDate: '',
    dischargeDate: '',
    connectionName: '',
    relationName: '',
    connectionType: '',
    relationship: '',
  },
  rebate: {},
  confirmation: false,
  referenceData: null,
};

const initialState = {
  initialData: cloneDeep(commonState),
  updatedData: cloneDeep(commonState),
};

export default {
  namespaced: true,

  state: cloneDeep(initialState),

  mutations: {
    updateCaptureInformationReferenceData(state, data) {
      state.updatedData.referenceData = data;
    },
    updatePolicyChanges(state, data) {
      state.updatedData.policyChanges = data;
    },
    updatePolicyHolder(state, data) {
      state.updatedData.policyHolder = data;
    },
    updatePartner(state, data) {
      state.updatedData.partner = data;
    },
    updateChildren(state, data) {
      state.updatedData.children = data;
    },
    updateEligibility(state, data) {
      state.updatedData.eligibility = data;
    },
    updateRebate(state, data) {
      state.updatedData.rebate = data;
    },
    updateConfirmation(state, data) {
      state.updatedData.confirmation = data;
    },
    updateInitialData(state, data) {
      state.initialData = JSON.parse(JSON.stringify(data));
    },
    updateInitialPolicyHolderLhc(state, data) {
      state.initialData.policyHolder.lhc = cloneDeep(data);
    },
    updateInitialPolicyHolderAbd(state, data) {
      state.initialData.policyHolder.abd = cloneDeep(data);
    },
    updateInitialPartnerLhc(state, data) {
      state.initialData.partner.lhc = data;
    },
    updateInitialPartnerAbd(state, data) {
      state.initialData.partner.abd = data;
    },
    updateInitialPolicyHolderPortalAbd(state, data) {
      state.initialData.policyHolder.portalAgeBasedDiscount = data;
    },
    updateInitialPartnerPortalAbd(state, data) {
      state.initialData.partner.portalAgeBasedDiscount = data;
    },
    updateInitialPolicyHolderVeteranCard(state, data) {
      state.initialData.policyHolder.veteranCard = data;
    },
    updateInitialPartnerVeteranCard(state, data) {
      state.initialData.partner.veteranCard = data;
    },
    updateEligibilityInitialData(state, data) {
      state.initialData.eligibility = cloneDeep(data);
    },
    resetCAIData(state) {
      Object.assign(state, cloneDeep(initialState));
    },
  },

  getters: {
    getCaptureInformationReferenceData: (state) => {
      return state.updatedData.referenceData;
    },
    getPolicyChangesInformation: (state) => {
      return state.updatedData.policyChanges;
    },
    getPolicyHolderInformation: (state) => {
      return state.updatedData.policyHolder;
    },
    getPartnerInformation: (state) => {
      return state.updatedData.partner;
    },
    getChildrenInformation: (state) => {
      return state.updatedData.children;
    },
    getEligibilityInformation: (state) => {
      return state.updatedData.eligibility;
    },
    getRebateInformation: (state) => {
      return state.updatedData.rebate;
    },
    getConfirmation: (state) => {
      return state.updatedData.confirmation;
    },
    getCaptureAdditionalInformationData: (state) => {
      return state.updatedData;
    },
    getInitialPolicyHolderLhc: (state) => {
      return state.initialData.policyHolder.lhc;
    },
    getInitialPolicyHolderAbd: (state) => {
      return state.initialData.policyHolder.abd;
    },
    getInitialPartnerLhc: (state) => {
      return state.initialData.partner.lhc;
    },
    getInitialPartnerAbd: (state) => {
      return state.initialData.partner.abd;
    },
    getInitialPolicyHolderPortalAbd: (state) => {
      return state.initialData.policyHolder.portalAgeBasedDiscount;
    },
    getInitialPartnerPortalAbd: (state) => {
      return state.initialData.partner.portalAgeBasedDiscount;
    },
    getInitialData: (state) => {
      return state.initialData;
    },
  },
};
